import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="border-y border-eq-line bg-eq-light px-3 py-3 sm:px-4 sm:py-4" data-id="element-147" data-mp="3kqw3yjl330fl">
      <div className="mx-auto max-w-4xl" data-id="element-148" data-mp="3fycp7jantz97">
        <div className="mb-1.5 text-center" data-id="element-149" data-mp="3b0kobzs1f2sv">
          <h2 className="font-display text-xl font-extrabold uppercase leading-tight tracking-tight sm:text-4xl" data-id="element-150" data-mp="3azj8zj3znu5c">
            What Instructors Are Saying
          </h2>
          <p className="font-display text-[10.5px] font-bold uppercase tracking-wide text-eq-gold sm:text-sm" data-id="element-151" data-mp="32063t2mwdrqf">
            ⭐⭐⭐⭐⭐ 4.9/5 — Verified Customer Reviews
          </p>
        </div>
        <div className="grid gap-1.5 sm:grid-cols-2 sm:gap-2" data-id="element-152" data-mp="2s1qbwxg1qefv">
          {testimonials.map(testimonial => <article key={testimonial.author} className="flex flex-col rounded-lg border border-eq-line bg-white p-2.5 shadow-sm sm:p-3" data-id="element-153" data-mp="v9yh9eyp81bu">
              <div className="mb-1 flex gap-0.5" aria-label="Rated 5 out of 5" data-id="element-154" data-mp="h5y8oeopdd3m">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-3.5 w-3.5 fill-eq-gold text-eq-gold" aria-hidden="true" data-id="element-155" data-mp="m5b3blltfogr" />)}
              </div>
              <p className="mb-1.5 text-[12px] font-medium italic leading-snug text-eq-muted sm:text-sm" data-id="element-156" data-mp="c7dh13nio1qs">
                “{testimonial.text}”
              </p>
              <div className="mt-auto flex items-center gap-2 border-t border-eq-line pt-1.5" data-id="element-157" data-mp="14w28eayrsspc">
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-eq-navy font-display text-[13px] font-bold text-eq-goldLight" data-id="element-158" data-mp="q7648ozu3zu0">
                  {testimonial.author.charAt(0)}
                </span>
                <div className="leading-tight" data-id="element-159" data-mp="1iuihu9o0oxb6">
                  <p className="font-display text-[12.5px] font-extrabold text-eq-navy" data-id="element-160" data-mp="1nm0hmueb0ruk">
                    {testimonial.author}
                  </p>
                  <p className="text-[10px] font-semibold uppercase tracking-wide text-eq-muted sm:text-[11px]" data-id="element-161" data-mp="1xhh4zsfud5k3">
                    {testimonial.role} — {testimonial.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}